import axios from 'axios';
const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';
function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return { Authorization: `Bearer ${auth.token}` };
}
function get(path, params) {
  return axios.get(`${API_BASE}${path}`, { headers: authHeader(), params }).then(r => r.data);
}

export const detect = (query) => get('/lookup/detect', { query });

export const phoneAppointments = (phone) => get(`/lookup/phone/${encodeURIComponent(phone)}/appointments`);
export const phoneOrders       = (phone) => get(`/lookup/phone/${encodeURIComponent(phone)}/orders`);
export const phoneSummary      = (phone) => get(`/lookup/phone/${encodeURIComponent(phone)}/summary`);
export const phoneInFlight     = (phone) => get(`/lookup/phone/${encodeURIComponent(phone)}/in-flight`);

export const appointmentDetail       = (uid) => get(`/lookup/appointment/${encodeURIComponent(uid)}/detail`);
export const appointmentOrderSummary = (uid) => get(`/lookup/appointment/${encodeURIComponent(uid)}/order-summary`);
export const appointmentStatusHistory = (uid, mode) =>
  get(`/lookup/appointment/${encodeURIComponent(uid)}/status-history`, { mode });
export const appointmentHandledBy = (uid) => get(`/lookup/appointment/${encodeURIComponent(uid)}/handled-by`);
export const appointmentNextAction = (uid) => get(`/lookup/appointment/${encodeURIComponent(uid)}/next-action`);

export const designDetails       = (code) => get(`/lookup/design/${encodeURIComponent(code)}/details`);
export const designInventoryCount = (code) => get(`/lookup/design/${encodeURIComponent(code)}/inventory-count`);
export const designUnitsSold     = (code, range) => get(`/lookup/design/${encodeURIComponent(code)}/units-sold`, { range });
export const designSellThrough   = (code) => get(`/lookup/design/${encodeURIComponent(code)}/sell-through`);
export const designStockBySize   = (code) => get(`/lookup/design/${encodeURIComponent(code)}/stock-by-size`);

export const barcodePriceHistory = (bc) => get(`/lookup/barcode/${encodeURIComponent(bc)}/price-history`);
export const barcodeSaleInfo     = (bc) => get(`/lookup/barcode/${encodeURIComponent(bc)}/sale-info`);
export const barcodeRecentAppointments = (bc) => get(`/lookup/barcode/${encodeURIComponent(bc)}/recent-appointments`);
